function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import UniverseStarComponent from "./universe-star/universe-star-component";
import DefaultProps from "./default-props";
const UniverseStars = (props)=>{
    const { stars } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: stars.map((star, index)=>{
            return /*#__PURE__*/ _jsx(UniverseStarComponent, _object_spread({
                leftRange: 3,
                rightRange: 10
            }, star), `star-${index}`);
        })
    });
};
export default UniverseStars;
UniverseStars.defaultProps = DefaultProps;
